import { cn } from '@/lib/utils';

interface AppLoaderProps {
  message?: string;
  className?: string;
}

export function AppLoader({ message = 'Initializing app...', className }: AppLoaderProps) {
  return (
    <div
      className={cn(
        'min-h-screen bg-background flex flex-col items-center justify-center',
        className
      )}
    >
      <div className="text-center space-y-8">
        {/* Logo */}
        <div className="flex justify-center">
          <img
            src="/goreeva_logo.png"
            alt="Goreeva"
            className="w-[70%] h-auto object-contain opacity-40"
          />
        </div>

        {/* Welcome text */}
        <div className="space-y-4">
          <h1 className="text-3xl font-bold text-muted-foreground">Welcome to Goreeva</h1>
          <p className="text-lg text-muted-foreground/80">{message}</p>
        </div>

        {/* Subtle loading indicator */}
        <div className="flex justify-center space-x-1">
          <div
            className="w-2 h-2 bg-muted-foreground/40 rounded-full animate-bounce"
            style={{ animationDelay: '0ms' }}
          ></div>
          <div
            className="w-2 h-2 bg-muted-foreground/40 rounded-full animate-bounce"
            style={{ animationDelay: '150ms' }}
          ></div>
          <div
            className="w-2 h-2 bg-muted-foreground/40 rounded-full animate-bounce"
            style={{ animationDelay: '300ms' }}
          ></div>
        </div>
      </div>
    </div>
  );
}
